import { apiClient } from "../client-api";
import { authHeader } from "@/_helpers";
import appConfig from "@/app.config";
// const appConfig = {
//   apiURL: "https://api.solicitapp.com/wp-json/",
//   jwtPath: "jwt-auth/v1/",
//   sappPath: "sapp/v2/"
// };

export default {
  login(username, password) {
    const body = { username, password };
    return apiClient
      .post(appConfig.jwtPath + "token", body, { headers: authHeader() })
      .then(response => {
        // console.log(response.data);
        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  },
  validate() {
    return apiClient
      .post(appConfig.jwtPath + "token/validate", {}, { headers: authHeader() })
      .then(response => {
        console.log(response.data);
      })
      .catch(err => {
        console.log(err);
      });
  },
  getCurrentAccount() {
    return apiClient
      .get("sapp/v2/current-account", { headers: authHeader() })
      .then(responose => {
        return Promise.resolve(responose.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  },
  // Verify if username exist
  usernameExist(username) {
    const body = {
      user_login: username
    };
    return apiClient
      .post(appConfig.sappPath + "username-exist/", body)
      .then(responose => {
        return Promise.resolve(responose.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  },
  // Request password reset key
  rpKeyRequest(username) {
    const body = {
      user_login: username
    };
    return apiClient
      .post(appConfig.sappPath + "request-rpkey/", body)
      .then(responose => {
        return Promise.resolve(responose.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  },
  // Verify password reset key
  rpKeyVerify(username, rpkey) {
    const body = {
      user_login: username,
      key: rpkey
    };
    return apiClient
      .post(appConfig.sappPath + "verify-rpkey/", body)
      .then(responose => {
        return Promise.resolve(responose.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  },
  // Change password
  resetPassword(username, rpkey, password) {
    const body = {
      rpkey: rpkey,
      username: username,
      password: password
    };
    return apiClient
      .post(appConfig.sappPath + "reset-password/", body)
      .then(responose => {
        return Promise.resolve(responose.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.message);
      });
  }
};
